// @flow

import Logger from 'roarr';

export default Logger.child({
  package: 'slonik'
});
